<template>
    <div class="maskmission" v-show="missionshow" @click="clear">
        <img class="bubble2" src="~assets/images/bubble2.png" alt="">
        <span class="bubble2msg">
          玩游戏赚金币和抽奖券
          <br>
          快开始吧！
        </span>
    </div>
</template>

<script>
import $ from 'jquery'
import vm from '../../main'
export default {
    props:['missionshow'],
    methods:{
      clear(){
        vm.$children[0].$children[0].missionshow = false
        document.querySelector('.missionhand').style.display = 'none'
        document.querySelector('.hand').style.display = 'none'
        vm.$children[0].$children[0].$el.style.overflowY = 'scroll'
        $("#topImg").css('top','')
        document.querySelector('.showmission').style.zIndex = 0;
      }
    }
}
</script>
<style scoped  lang="less">
button, p{
	margin: 0;
	padding: 0;
}
.maskmission{
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top:0;
  background: rgba(0,0,0,.75);
  z-index:100;
}
.bubble2{
  width: 70%;
  height: auto;
  position: absolute;
  top: 1.7rem;
  left: 15%;
}
.bubble2msg{
  display: block;
  font-size: 0.15rem;
  font-weight: 500;
  color: #fff;
  width: 75%;
  text-align: center;
  position: absolute;
  top: 2.4rem;
  left: 13%;
}
</style>